<script lang="ts" setup>

</script>

<template>
  <div class="container-fluid">
    <div class="footer">
      <a
        href="/legal/privacy-policy.pdf"
        target="_blank"
      >
        Политика в отношении обработки персональных данных
      </a>
      <a
        href="/legal/public-contract.pdf"
        target="_blank"
      >
        Договор-оферта
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer {
  display: flex;
  gap: rem(8px) rem(12px);
  padding: rem(10px) 0;
  border-top: 1px solid $gray-300;
  flex-wrap: wrap;

  & a {
    color: $gray-600;
    transition: all .2s ease-in-out;

    @media (any-hover: hover) {
      &:hover {
        color: $indigo-600;
      }
    }
  }
}
</style>
